var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasSecurityGuards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.553 12.086L20.687 23.5H3.5L.635 12.086C5.648 10.295 4.574 6.021 3.5 2.082L7.797.661c.357 3.58 8.235 3.585 8.594.005l4.297 1.413c-1.075 3.939-2.149 8.216 2.865 10.007z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24 14.5h7.354c1.104 0 2 .897 2 2v2a2 2 0 01-2 2H2.746m20.199-6h-7.352a2 2 0 00-2 2v2a2 2 0 002 2h5.847M7.797.661c1.188 9.789 7.406 9.781 8.594.005M9.594 11.5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2a1 1 0 011 1v1zm8 0a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2a1 1 0 011 1v1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.994 17.5h3.6m16.599 0h-3.599",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.553 12.086L20.687 23.5H3.5L.635 12.086C5.648 10.295 4.574 6.021 3.5 2.082L7.797.661c.357 3.58 8.235 3.585 8.594.005l4.297 1.413c-1.075 3.939-2.149 8.216 2.865 10.007z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24 14.5h7.354c1.104 0 2 .897 2 2v2a2 2 0 01-2 2H2.746m20.199-6h-7.352a2 2 0 00-2 2v2a2 2 0 002 2h5.847M7.797.661c1.188 9.789 7.406 9.781 8.594.005M9.594 11.5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2a1 1 0 011 1v1zm8 0a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1a1 1 0 011-1h2a1 1 0 011 1v1z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.994 17.5h3.6m16.599 0h-3.599",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgHasSecurityGuards;